import type { Lesson } from "@edu/shared";

/**
 * Склейка страниц завершённых уроков.
 *
 * ⚠️ **Занятие группы может приехать дважды, и второй раз его надо пропустить.**
 * Сервер режет страницы по УРОКАМ, а в списке занятие группы стоит одной
 * строкой. Чтобы строка не рвалась с неверным размером, сервер добирает к
 * странице все уроки её сеансов (`listEndedLessonsPage` в API), и хвостовой
 * урок того же сеанса может снова лечь на следующую страницу, уже целой
 * строкой. Показывать её второй раз нельзя.
 *
 * Ключ строки ровно тот же, что у свёртки на сервере (`collapseRoomLessons`):
 * сеанс, если это занятие группы и я его преподаватель, иначе сам урок. У
 * ученика свёртки нет, его урок в комнате ровно один.
 */
export function lessonRowKey(l: Lesson): string {
  return l.myRole === "teacher" && l.groupSessionId != null ? `s:${l.groupSessionId}` : `l:${l.id}`;
}

/** Дописать страницу к показанному, пропуская строки, которые уже показаны. */
export function appendLessonPage(shown: readonly Lesson[], page: readonly Lesson[]): Lesson[] {
  const seen = new Set(shown.map(lessonRowKey));
  const out = [...shown];
  for (const l of page) {
    const key = lessonRowKey(l);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(l);
  }
  return out;
}
